
import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  maxWidth = 'md',
}) => {
  const maxWidthClasses = {
    sm: 'sm:max-w-[425px]',
    md: 'sm:max-w-[600px]',
    lg: 'sm:max-w-[800px]',
    xl: 'sm:max-w-[1000px]',
    '2xl': 'sm:max-w-[1200px]',
    'full': 'sm:max-w-[95vw] sm:max-h-[90vh]',
  };
  
  const showHeader = title || description;
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`${maxWidthClasses[maxWidth]} w-[calc(100%-1.25rem)] max-h-[90dvh] p-4 sm:p-6 flex flex-col bg-background border-border shadow-xl`}>
        {showHeader && (
          <DialogHeader className="pb-4 sm:pb-6 border-b border-border/50 flex-shrink-0 pr-8">
            {title && <DialogTitle className="text-xl sm:text-2xl font-semibold text-foreground">{title}</DialogTitle>}
            {description ? (
              <DialogDescription className="text-muted-foreground mt-2 text-sm">{description}</DialogDescription>
            ) : (
              <DialogDescription className="sr-only">{`${title} dialog`}</DialogDescription>
            )}
          </DialogHeader>
        )}
        
        <div className="flex-1 overflow-y-auto px-1 sm:px-6 py-3 sm:py-4 -mx-1 sm:mx-0">
          {children}
        </div>
        
        {footer && <DialogFooter className="pt-4 sm:pt-6 border-t border-border/50 flex-shrink-0">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
